import {
  UPDATE_ALBUM_FILTER,
  TOGGLE_ALBUM_SORT_OPTION,
  TOGGLE_ALBUM_SORT_OPTION_DIRECTION,
} from './cssActions';
import {
  ADMIN_CSS,
  ALBUM_DATE_STATUS,
  SORT_DIRECTION,
  WEB_GALLERY_STATUS,
  JOIN_CODE_FILTER,
} from '../../constants/admin';
import { ALBUM_TYPE, ALBUM_SUBTYPE } from '../../../../constants/albums';

export const initialState = {
  albumsFilter: {
    limit: ADMIN_CSS.ALBUM_MONITORING_PER_PAGE,
    offset: 0,
    dateStatus: ALBUM_DATE_STATUS.MONITORING_ACTIVE,
    albumName: undefined,
    organizationName: undefined,
    page: 0,
    commanderEnabled: ADMIN_CSS.COMMANDER_ENABLED_TO_DEFAULT_VALUE,
    assignedTo: ADMIN_CSS.ASSIGNED_TO_DEFAULT_VALUE,
    webGalleryStatus: WEB_GALLERY_STATUS.ALL,
    albumDate: null,
    albumType: ALBUM_TYPE.PRO,
    albumSubtype: ALBUM_SUBTYPE.CAMPS,
    joinCodeFilter: JOIN_CODE_FILTER.ALL,
    selectedAlbumFolders: [],
    selectedAlbums: [],
  },
  albumsSortOptions: [],
};

const cssReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case UPDATE_ALBUM_FILTER:
      return {
        ...state,
        albumsFilter: {
          ...state.albumsFilter,
          ...action.filter,
          // Offset is updated by the new page or the prev. Limit is a constant and
          // Shouldn't be changed
          offset:
            action.filter.page === 0
              ? 0
              : (action.filter.page || state.albumsFilter.page) *
                state.albumsFilter.limit,
        },
      };
    case TOGGLE_ALBUM_SORT_OPTION:
      return {
        ...state,
        albumsSortOptions: state.albumsSortOptions.find(
          option => option.field === action.option.field,
        )
          ? state.albumsSortOptions.filter(
              option => option.field !== action.option.field,
            )
          : [
              ...state.albumsSortOptions,
              {
                direction: SORT_DIRECTION.DESC,
                ...action.option,
              },
            ],
      };
    case TOGGLE_ALBUM_SORT_OPTION_DIRECTION:
      return {
        ...state,
        albumsSortOptions: state.albumsSortOptions.map(option => {
          if (option.field !== action.option.field) {
            return option;
          }

          return {
            ...option,
            direction:
              option.direction === SORT_DIRECTION.DESC
                ? SORT_DIRECTION.ASC
                : SORT_DIRECTION.DESC,
          };
        }),
      };
    default:
      return state;
  }
};

export default cssReducer;
